import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';

export const Row = styled(Flex)
    .withConfig({ displayName: 'Row' })
    .attrs((props) => ({
        py: 1,
        ...props,
        spacing: 1,
        width: '100%',
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: props.borderTop ?? '1px solid var(--divider)',
    }))`
    -webkit-user-drag: none;
    user-drag: none;
    user-select: none;
`;

export const ControlColumn = styled(Flex).withConfig({ displayName: 'ControlColumn' }).attrs({
    minWidth: 48,
    minHeight: 52,
    flexBasis: 0,
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
})``;

export const ContentColumn = styled(Flex)
    .withConfig({ displayName: 'ContentColumn' })
    .attrs((props: FlexProps) => ({
        px: 1,
        flexGrow: 1,
        py: 0.5,
        alignSelf: 'stretch',
        ...props,
        direction: 'column',
        justifyContent: props.justifyContent ?? 'space-between',
    }))``;

export const DateColumn = styled(Flex)
    .withConfig({ displayName: 'DateColumn' })
    .attrs({
        display: { xs: 'none', sm: 'flex' },
        minWidth: 120,
        px: 1,
        flexBasis: 0,
        flexShrink: 0,
        justifyContent: 'center',
        alignItems: 'flex-end',
    })``;
